module.exports = __webpack_public_path__ + "3da9f1774b4773bda0c7216e4235388e.png";